import type { HTMLAttributes } from "react";
import type { Components } from "react-markdown";

import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";

import { cn } from "@alaffia-technology-solutions/tailwind-utils";

import { coy } from "react-syntax-highlighter/dist/cjs/styles/prism";

interface CodeBlockProps extends HTMLAttributes<HTMLDivElement> {
  children: string;
  language: string;
}

const style = {
  ...coy,
  ".language-css .token.string": {
    ...coy[".language-css .token.string"],
    background: "transparent",
  },
  ".style .token.string": {
    ...coy[".style .token.string"],
    background: "transparent",
  },
  entity: {
    ...coy.entity,
    background: "transparent",
  },
  operator: {
    ...coy.operator,
    background: "transparent",
  },
};
const CodeBlock = ({
  children,
  className,
  language,
  ...rest
}: CodeBlockProps) => (
  <div
    className={cn(
      "af-mt-6 af-rounded-md af-border af-border-border af-bg-accent",
      className,
    )}
    {...rest}
  >
    <SyntaxHighlighter
      customStyle={{
        backgroundColor: "hsl(var(--alaffia-gray-100))",
      }}
      language={language}
      PreTag="div"
      style={style}
    >
      {children}
    </SyntaxHighlighter>
  </div>
);

const lanuageRegex = /language-(\w+)/;

const matchLanguage = (className: string) => lanuageRegex.exec(className)?.[1];

const transformCodeBlockChildren = (children: string) =>
  children.replace(/\n$/, "");

export const Code: Components["code"] = ({ children, className, ...rest }) => {
  const language = className ? matchLanguage(className) : null;

  const isCodeBlock = typeof children === "string" && language;

  if (isCodeBlock) {
    return (
      <CodeBlock className={className} language={language}>
        {transformCodeBlockChildren(children)}
      </CodeBlock>
    );
  }

  return (
    <code className={cn("af-mt-6", className)} {...rest}>
      {children}
    </code>
  );
};
